module.exports = __webpack_public_path__ + "img/3b337921e04b6b4474d30684bfa430b9.a72f8730.svg";